import { ConfigProvider, Layout, Dropdown, Menu } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import classnames from 'classnames';
import { LoginApi, UserApi } from 'gmrfid-service-user-api-client';
import { CommonApi } from 'gmrfid-service-user-api-manager';
import { useEffect, useState } from 'react';
import { imgUrlHandle } from '@/utils';
import { ContainerQuery } from 'react-container-query';
import { styled, useHistory, useLocation } from 'troyfe';
import Header from '../components/Header';
import SideMenu from '../components/SideMenu';
import 'moment/locale/zh-cn';
import defaultSettingsObj from '../defaultSettings';
import store from '@/store';

const { menuLayout, navTheme } = defaultSettingsObj;

const query = {
  'screen-xs': {
    maxWidth: 575,
  },
  'screen-sm': {
    minWidth: 576,
    maxWidth: 767,
  },
  'screen-md': {
    minWidth: 768,
    maxWidth: 991,
  },
  'screen-lg': {
    minWidth: 992,
    maxWidth: 1199,
  },
  'screen-xl': {
    minWidth: 1200,
    maxWidth: 1599,
  },
  'screen-xxl': {
    minWidth: 1600,
  },
};

const Content = styled(Layout.Content)`
  margin: 8px 20px;
  background: #fff;
  flex-grow: 1;
  flex-basis: 0;
  box-sizing: border-box;
`;

const RouterTabs = styled.ul`
  display: flex;
  height: 40px;
  flex: 0 0 40px;
  background: #fff;
  margin: 0 20px;
  li {
    min-width: 125px;
    display: flex;
    border-right: 1px solid #f1f2f4;
    cursor: pointer;
    font-size: 14px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    padding: 0 0 0 20px;
    color: #666666;
    .clear {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 5px;

      .clearIcon {
        width: 13px;
        height: 13px;
        background-color: transparent;
        cursor: pointer;
        border-radius: 50%;
        flex-shrink: 0;
        background-image: url(/header/header-close.png);
        background-repeat: no-repeat;
        background-size: 13px 13px;
      }
    }
    &:hover {
      color: #44bb55;
    }
  }
`;

const Layouts = (props) => {
  const [appState, appDispatchers] = store.useModel('app');
  const { isRefresh, appConfig } = appState;
  // const { isRefresh } = useSelector((state) => state.app);
  const [collapsed, setCollapsed] = useState(false);
  const [backVisible, setBackVisible] = useState(false);
  const [currentCrumbs, setCurrentCrumbs] = useState({});
  const locations = useLocation();
  const history = useHistory();
  // const dispatch = useDispatch();
  const [routesData, setRoutesData] = useState([]);
  // 获取当前用户的角色、权限
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
  const user = JSON.parse(sessionStorage.getItem('user'));
  const navData = JSON.parse(sessionStorage.getItem('nav'));

  useEffect(() => {
    LoginApi.logo({
      key: process.env.NODE_ENV === 'development' ? 'wjmhadmin-dev.jmhvip.com' : window.location.host,
    }).then((res) => {
      localStorage.setItem('appConfig', JSON.stringify((res as any)?.data || '{}'));
      if (res?.data) {
        console.log('data', res.data);
        appDispatchers.updateStates({
          payload: {
            ...res.data,
          },
        });
        document.title = res?.data?.appConfig?.title || '';
        const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = imgUrlHandle(res.data?.appConfig?.icon?.logo2) || imgUrlHandle('logo/40_40.png'); // icon图标
        document.getElementsByTagName('head')[0].appendChild(link);
      }
    });
  }, []);
  useEffect(() => {
    if (!userInfo && !user) {
      history.push('/login');
    } else {
      setRoutesData(JSON.parse(sessionStorage.getItem('menu')));
    }
    if (userInfo) {
      UserApi.getUserInfoPC({}).then((res2: any) => {
        if (res2.status === 200) {
          appDispatchers.updateStates({
            payload: {
              basicInformation: {
                userInf: {
                  organizationInf: {},
                  userDetails: user || {},
                  organizationDetails: {},
                  user: res2.data,
                },
                organizationData: [],
              },
            },
          });
        }
      });
    }
  }, [locations.pathname, isRefresh]);

  /* 清除缓存 */
  const deleteCacheFn = () => {
    CommonApi.deletePermissionCache({}).then((res) => {});
  };

  /* 退出 */
  const signOut = () => {
    deleteCacheFn();
    setBackVisible(false);
    sessionStorage.clear();
    LoginApi.getDomain({}).then((res: any) => {
      sessionStorage.setItem('httpUrl', res.data);
    });
    history.push('/login');
  };

  /* 关闭左侧导航栏，跳转到套餐管理 */
  const mouseLeave = () => {
    // 清空 tab 导航，只保留套餐管理
    const menuList = JSON.parse(sessionStorage.getItem('menu') || '[]');
    const comboItem = menuList?.find((it) => it.uri === '/combo');
    if (comboItem) {
      sessionStorage.setItem('nav', JSON.stringify([{ ...comboItem, close: false }]));
      history.push('/combo');
    } else {
      history.push('/combo');
    }
  };

  const headerProps = {
    toggle: () => {
      setCollapsed(!collapsed);
    },
    menuLayout,
    collapsed,
    navTheme,
    signOut,
  };
  if (
    locations.pathname === '/login' ||
    locations.pathname === '/register' ||
    locations.pathname === '/platform' ||
    locations.pathname === '/informationRelease/showPage'
  ) {
    return <div>{props.children}</div>;
  }

  const menus = (
    <ul style={{
      background: '#fff',
      boxShadow: '0 0 2px #666666',
      width: '130px',
      height: '173px',
      padding: '8px 8px 0',
      position: 'absolute',
      right: '10px' }}
    >
      <li
        style={{
          padding: '8px 0',
          textAlign: 'center',
          cursor: 'pointer',
          width: '100%',
          fontSize: '12px',
          borderBottom: '1px solid rgb(240, 242, 245)',
        }}
        onClick={() => { mouseLeave(); }}
      >
        关闭所有
      </li>
    </ul>
  );

  const layout = (
    <Layout style={{ width: '100%', height: '100%' }}>
      {menuLayout === 'sidemenu' ? (
        <SideMenu
          theme={navTheme}
          collapsed={collapsed}
          routesData={routesData}
          setCurrentCrumbs={setCurrentCrumbs}
          currentCrumbs={currentCrumbs}
        />
      ) : null}
      <Layout style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <Header {...headerProps} />
        <RouterTabs className="router-tabs">
          {navData &&
            navData.map((it, i) => {
              const str = it.name && it.name.length > 4 ? `${it.name.slice(0, 4)}...` : it.name;
              const showClose = it.uri === '/' || it.uri === '/HYIndustryWorkbench' || it.uri === '/mallHome';
              return (
                <li
                  title={it.name}
                  key={i}
                  onClick={() => {
                    history.push({
                      pathname: it.uri,
                      state: it?.state,
                    });
                  }}
                  style={{
                    color: true ? '#44BB55' : '#666666',
                  }}
                >
                  <div className="name">{str}</div>
                  <div
                    className="clear"
                    onClick={(e) => {
                      e.stopPropagation();
                      const nav = JSON.parse(sessionStorage.getItem('nav'));
                      const key = nav.findIndex((s) => s.uri === it.uri);
                      const indexObj = key > -1 && key !== nav.length ? nav[key + 1] : {};
                      if (key > -1) {
                        if (showClose) return;
                        nav.splice(key, 1);
                        sessionStorage.setItem('nav', JSON.stringify(nav));
                        if (indexObj?.uri) {
                          history.push({
                            pathname: indexObj.uri,
                            state: indexObj,
                          });
                        } else {
                          history.push({
                            pathname: nav[nav.length - 1]?.uri,
                          });
                        }
                      }
                    }}
                  >
                    {!showClose && <div className="clearIcon" />}
                  </div>
                </li>
              );
            })}
          <li style={{ marginLeft: 'auto', minWidth: 'auto', display: 'flex', alignItems: 'center', padding: '0 20px' }}>
            <Dropdown overlay={menus} trigger={['hover']}>
              <img src="/header/header-more@2x.png" alt="查看更多" width={16} height={16} />
            </Dropdown>
          </li>
        </RouterTabs>
        <Content>{props.children}</Content>
        <footer style={{ display: appConfig.link1 || appConfig.link2 || appConfig.link3 ? 'block' : 'none' }}>
          <a target="_blank" style={{ color: '#999' }} href={appConfig.link1} rel="noreferrer">
            {appConfig.copyright1}
          </a>
          <a target="_blank" style={{ color: '#999' }} href={appConfig.link2} rel="noreferrer">
            {appConfig.copyright2}
          </a>

          <a target="_blank" style={{ color: '#999' }} href={appConfig.link3} rel="noreferrer">
            {appConfig.copyright3}
          </a>
        </footer>
      </Layout>
    </Layout>
  );

  return (
    <ConfigProvider locale={zhCN}>
      <ContainerQuery query={query}>
        {(params) => <div className={classnames(params)} style={{ width: '100%', height: '100%' }}>{layout}</div>}
      </ContainerQuery>
    </ConfigProvider>
  );
};

export default Layouts;
